module.exports = __webpack_public_path__ + "static/media/KhushiAdukia.ac3a834f.jpeg";